function devtricker_session_followUser(userId) {
    if (!devtricker_getTheLoggedUserId() || !userId) return;

    const key = 'devtricker_following_users';
    const following = JSON.parse(sessionStorage.getItem(key) || '{}');

    following[userId] = {
        followed: true,
        dateAdded: new Date().toISOString()
    };

    sessionStorage.setItem(key, JSON.stringify(following));
}

function devtricker_session_unfollowUser(userId) {
    if (!devtricker_getTheLoggedUserId() || !userId) return;

    const key = 'devtricker_following_users';
    const following = JSON.parse(sessionStorage.getItem(key) || '{}');

    following[userId] = { followed: false };

    sessionStorage.setItem(key, JSON.stringify(following));
}

function devtricker_session_isFollowing(userId) {
    if (!devtricker_getTheLoggedUserId() || !userId) return null;

    const key = 'devtricker_following_users';
    const following = JSON.parse(sessionStorage.getItem(key) || '{}');

    return following[userId]?.followed === true;
}

function devtricker_session_isFollowingRecent(userId) {
    if (!devtricker_getTheLoggedUserId() || !userId) return false;

    const key = 'devtricker_following_users';
    const following = JSON.parse(sessionStorage.getItem(key) || '{}');
    const data = following[userId];

    if (!data?.followed || !data.dateAdded) return false;

    const pageGeneratedTimeMeta = document.querySelector('meta[name="page-generated-time"]');
    if (!pageGeneratedTimeMeta) return false;

    const pageGeneratedTime = new Date(pageGeneratedTimeMeta.content);
    const followedTime = new Date(data.dateAdded);

    return pageGeneratedTime <= followedTime;
}

function devtricker_session_getAllFollowingIds() {
    if (!devtricker_getTheLoggedUserId()) return [];

    const key = 'devtricker_following_users';
    const following = JSON.parse(sessionStorage.getItem(key) || '{}');

    return Object.entries(following)
        .filter(([_, data]) => data.followed === true)
        .map(([userId]) => userId);
}

function devtricker_session_getAllKnownUserIds() {
    if (!devtricker_getTheLoggedUserId()) return [];

    const key = 'devtricker_following_users';
    const following = JSON.parse(sessionStorage.getItem(key) || '{}');

    return Object.keys(following);
}